<template lang="pug">
.volume.surface-bg(:class="{active:activated}")
  .value {{volume}}
  .bar.surface-bg-darker
    .state(:style="{ height: height }")
  .muted
    i.fas(:class="{'fa-volume-slash': muted, 'fa-volume': !muted}")
</template>

<script>
export default {
  name: "volume",
  data() {
    return {
      activated: false,
      index: "0",
      timeout: null,
      volume: 0,
      muted: false
    }
  },
  computed: {
    height() {
      return this.volume + "%"
    }
  },
  watch: {
    activated(nval) {
      this.$emit("activate", { name: this.$options.name, state: nval })
      this.index = nval ? "109" : "109"
    }
  },
  mounted() {
    _$.vue.$on("volume", this.activate)
    _$.vue.$on("beforeRoute", () => this.close())
  },
  methods: {
    async activate(payload) {
      if (!payload) return this.close()
      const { volume, muted, activate } = payload

      if (volume >= 0) {
        this.volume = volume
        this.muted = false
      }
      if ([false, "false", true, "true"].includes(muted)) this.muted = muted

      this.activated = [false, "false"].includes(activate) ? false : true

      if (this.timeout) this.timeout = window.clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.close(), 3000)
    },
    close() {
      this.activated = false
    }
  }
}
</script>

<style lang="scss">
.volume {
  z-index: 99999;
  position: absolute;
  overflow: hidden;
  transform: translateX(100%);
  transform: translateY(-50%);
  visibility: hidden;
  color: #ffffff;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 20px;
  height: 400px;
  padding: 15px 30px;
  border-radius: 1in;

  top: 50%;
  right: 20px;

  &.active {
    transform: translateX(0);
    transform: translateY(-50%);
    visibility: visible;
  }

  .bar {
    flex: 1 1 auto;
    width: 5px;
    height: 100%;
    border-radius: 1in;
    overflow: hidden;
    position: relative;

    margin-top: 10px;
    margin-bottom: 10px;

    .state {
      background: #ffffff;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  .muted {
  }
}
</style>
